import { DateInput } from './DateInput';
import { TimeInput } from './TimeInput';

interface DateTimeInputProps {
  value?: string | null; // YYYY-MM-DDTHH:mm
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export function DateTimeInput({
  value,
  onChange,
  min,
  max,
  required = false,
  disabled = false,
  className = '',
}: DateTimeInputProps) {
  const date = value?.split('T')[0] ?? '';
  const time = value?.split('T')[1]?.slice(0, 5) ?? '';

  const minDate = min?.split('T')[0];
  const maxDate = max?.split('T')[0];

  const handleDateChange = (newDate: string) => {
    if (!newDate) {
      onChange('');
      return;
    }

    onChange(`${newDate}T${time || '00:00'}`);
  };

  const handleTimeChange = (newTime: string) => {
    if (!date) return;

    onChange(`${date}T${newTime}`);
  };

  return (
    <div className={`grid grid-cols-[1fr_auto] gap-2 ${className}`}>
      <DateInput
        value={date}
        onChange={handleDateChange}
        min={minDate}
        max={maxDate}
        required={required}
        disabled={disabled}
        className="input-field"
      />

      <TimeInput
        value={time}
        onChange={handleTimeChange}
        required={required}
        disabled={disabled}
        className="input-field w-32"
      />
    </div>
  );
}